import styled from 'styled-components'

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: rgba(0,0,0,0.3);
`
export const ModalContainer = styled.div`
    width: 100%;
    height: 646px;
    background-color: #2c281d;
    position: absolute;
    top: 35%;
    left: 0;
    transform: translate(0,-20%);
`

export const IconWrapper = styled.div`
    position: relative;
    width: 100%;
`

export const Icon = styled.div`
    position: absolute;
    right: 16px;
    top: 16px;
`

export const StoriesWrapper = styled.div`
    margin: 0 auto;
    height: 100%;
    width: 360px;
`

export const BottomCaption = styled.p`
	text-align: center;
	color: white;
	position: relative;
`

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-top: 24px;
`
export const HeaderImageWrapper = styled.div`
    margin-right: 16px;
`
export const HeaderImage = styled.img`
    width: 36px;
    height: 36px;
    border-radius: 50%;
`

export const HeaderContent = styled.div`
    color: #fff;
`

export const HeaderTitle = styled.div`
    font-size: 16px;
    font-weight: 600;
`

export const HeaderSubTitle = styled.div`
    font-size: 12px;
` 